var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.975.575A14.2 14.2 0 0 0 14.087 0h-.093C6.269 0 0 6.269 0 14s6.269 14 14 14c2.5 0 4.844-.656 6.875-1.8.025-.012.05-.031.075-.044a14 14 0 0 0 3.038-2.35c-.97.256-1.988.388-3.038.388q-.3-.001-.6-.013C14.019 23.87 8.981 18.62 8.981 12.194a12.01 12.01 0 0 1 9-11.631zm-6.981 1.806A13.97 13.97 0 0 0 6.98 12.2c0 6.35 4.219 11.713 10 13.425-.95.244-1.95.375-2.981.375-6.625 0-12-5.375-12-12C2 8.413 5.819 3.713 10.994 2.381"
  })));
};
export default SvgMoon;